<template>
  <v-app>
    <v-main>
      <v-row no-gutters>
        <v-col cols="12" lg="7" sm="6" v-if="$vuetify.breakpoint.smAndUp">
          <v-sheet
            class="pa-12 d-flex flex-column justify-center align-center"
            color="grey lighten-3"
            style="height: 100vh; position: sticky; top: 0;"
          >
            <img alt="logo" class="mx-auto mb-8" src="@/assets/logo.svg" width="240" />
            <div
              class="text-h6 text-center text--secondary"
            >Klass.lk is an education management system built for individuals to large institutes to manage their class operations in one single dashboard.</div>
            <img alt="teaching" src="@/assets/images/teaching.png" style="max-height: 70%; max-width: 100%" />
          </v-sheet>
        </v-col>

        <v-col
          :style="{minHeight: $isMobileDevice? '100vh': 'auto'}"
          cols="12"
          lg="5"
          sm="6"
          style="position: relative;"
        >
          <v-stepper :value="step" alt-labels class="mx-5 mt-5 rounded-lg stepper" v-if="step < 4">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">Contact Details</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Verification</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 3" step="3">Institute Details</v-stepper-step>
            </v-stepper-header>
          </v-stepper>

          <div>
            <router-view />
          </div>

          <v-footer absolute color="transparent">
            <div
              class="py-2 text-center text-body-2"
              style="width: 100%"
            >Copyright &copy; {{ new Date().getFullYear() }} Klass.lk. All Rights Reserved.</div>
          </v-footer>
        </v-col>
      </v-row>
    </v-main>

    <snackbar-queue />
  </v-app>
</template>

<script>
export default {
  name: "RegistrationLayout",

  computed: {
    step() {
      switch (this.$route.name) {
        case "ContactDetails":
          return 1;
        case "Verification":
          return 2;
        case "InstituteDetails":
          return 3;
        default:
          return 4;
      }
    },
  },
};
</script>

<style scoped>
.stepper {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 12px !important;
}
.stepper >>> .v-stepper__label {
  text-align: center;
}
</style>